<template>
  <b-card>
    <b-form @submit.prevent="save">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Evento" label-for="evento">
            <v-select
              id="evento"
              v-model="eventManager.evento"
              :options="eventos"
              label="nome"
              :reduce="(evento) => evento"
              placeholder="Selecione o evento"
              required
            >
              <template #no-options>
                <div class="text-muted">Nenhum evento encontrado</div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Responsável" label-for="responsavel">
            <v-select
              id="responsavel"
              v-model="eventManager.responsavel"
              :options="responsaveis"
              label="nome"
              :reduce="(resp) => resp"
              placeholder="Selecione o responsável"
              required
            >
              <template #no-options>
                <div class="text-muted">Nenhum responsável encontrado</div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-checkbox
            v-model="eventManager.ativo"
            name="ativo"
            switch
          >
            {{ eventManager.ativo ? 'Ativo' : 'Inativo' }}
          </b-form-checkbox>
        </b-col>

        <ButtonsFormVue
          :permission-insert="verificarPermissao('ROLE_ADMIM_INSERIR')"
          :permission-edit="verificarPermissao('ROLE_ADMIM_ATUALIZAR')"
          :disable-form="false"
          @save="save"
          @cancel="cancel"
        />
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import { mapState } from 'vuex';
import {
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  BCard,
  BForm,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue';
import { verificarPermissao } from '@/auth/utils';

export default {
  name: 'EventManagerForm',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    BCard,
    BForm,
    vSelect,
    ButtonsFormVue,
  },
  data() {
    return {
      verificarPermissao,
      eventos: [],
      responsaveis: [],
    };
  },
  computed: {
    ...mapState('eventManagerSettingsModule', {
      eventManager: (state) => state.eventManager,
    }),
  },
  created() {
    this.loadDependencies();
  },
  methods: {
    async loadDependencies() {
      try {
        // TODO: Replace with actual API calls
        // this.eventos = await this.$http.get('/api/eventos');
        // this.responsaveis = await this.$http.get('/api/usuarios');
      } catch (error) {
        console.error('Error loading dependencies:', error);
      }
    },
    save() {
      const payload = {
        ...this.eventManager,
        evento: { id: this.eventManager.evento?.id },
        responsavel: { id: this.eventManager.responsavel?.id },
      };

      if (this.eventManager.id) {
        this.$store.dispatch('eventManagerSettingsModule/edit', payload);
      } else {
        this.$store.dispatch('eventManagerSettingsModule/insertNew', payload);
      }
    },
    cancel() {
      this.$emit('cancelar');
      this.$store.dispatch('eventManagerSettingsModule/reset');
    },
  },
};
</script>
